import axios from "axios";

export const getAllAnggaranPemasukan = async () => {
  return await axios.get(`${window._HOST}admin/anggaranPemasukan/`, {
    withCredentials: true,
  });
};

export const getAllDetailAnggaranPemasukan = async () => {
  return await axios.get(`${window._HOST}admin/anggaranPemasukan/detail`, {
    withCredentials: true,
  });
};

export const getAllDataTableAnggaranPemasukan = async (
  searchText = null,
  offset = 0,
  limit = 0,
  $sortingCol = 0,
  sortingMode = "DESC"
) => {
  if (searchText) {
    return await axios.get(
      `${window._HOST}admin/anggaranPemasukan/dataTable?search-text=${searchText}&offset=${offset}&limit=${limit}&sorting-col=${$sortingCol}&sorting-mode=${sortingMode}`,
      { withCredentials: true }
    );
  } else {
    return await axios.get(
      `${window._HOST}admin/anggaranPemasukan/dataTable?offset=${offset}&limit=${limit}&sorting-col=${$sortingCol}&sorting-mode=${sortingMode}`,
      { withCredentials: true }
    );
  }
};

export const getDropdownAnggaranPemasukan = async () => {
  return await axios.get(`${window._HOST}/admin/anggaranPemasukan/dropdown`, {
    withCredentials: true,
  });
};

export const getDropdownTahunAnggaranPemasukan = async () => {
  return await axios.get(
    `${window._HOST}admin/anggaranPemasukan/tahunAnggaran`,
    { withCredentials: true }
  );
};

export const getFilteredAnggaranPemasukan = async (condition) => {
  return await axios.post(
    `${window._HOST}admin/anggaranPemasukan/filteredData`,
    condition,
    { withCredentials: true }
  );
};

export const insertAnggaranPemasukan = async (formData) => {
  return await axios.post(`${window._HOST}admin/anggaranPemasukan/`, formData, {
    withCredentials: true,
  });
};

export const updateAnggaranPemasukan = async (formData, id) => {
  return await axios.put(
    `${window._HOST}admin/anggaranPemasukan/${id}`,
    formData,
    { withCredentials: true }
  );
};

export const deleteAnggaranPemasukan = async (id) => {
  return await axios.delete(`${window._HOST}admin/anggaranPemasukan/${id}`, {
    withCredentials: true,
  });
};
